import React from 'react';
interface RichTextProps {
  text: string;
}
export function RichText({
  text
}: RichTextProps) {
  return <div style={{
    lineHeight: 1.6
  }} data-id="element-152">
      {text.split('\n').map((line, i) => {
      const isBullet = line.trimStart().startsWith('•');
      const content = isBullet ? line.trimStart().slice(1).trim() : line;
      const parts = content.split(/(\*\*[^*]+\*\*)/g).map((p, j) => p.startsWith('**') && p.endsWith('**') ? <strong key={j} style={{
        fontWeight: 700,
        color: '#1C2530'
      }} data-id="element-153">
              {p.slice(2, -2)}
            </strong> : <span key={j} data-id="element-154">{p}</span>);
      if (isBullet) return <div key={i} style={{
        display: 'flex',
        gap: 8,
        marginBottom: 6,
        paddingLeft: 2
      }} data-id="element-155">
              <span style={{
          color: '#94A3B8',
          flexShrink: 0
        }} data-id="element-156">
                •
              </span>
              <span data-id="element-157">{parts}</span>
            </div>;
      if (!line.trim()) return <div key={i} style={{
        height: 10
      }} data-id="element-158" />;
      return <div key={i} style={{
        marginBottom: 3
      }} data-id="element-159">
            {parts}
          </div>;
    })}
    </div>;
}